//
//
//
//
//
//
//
//

export default {
  props: {
    caption: String,
    indent: {
      type: Boolean,
      default: true
    }
  }
}
